import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _class, _class2, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "c039ex8GAJBCKtgHrijprJ5", "AdCtr", undefined);

import { sys, _decorator } from "cc";
import AdChuanYin from "../ad/chuanYin/AdChuanYin";
import AdCocos from "../ad/cocos/AdCocos";
import AdCocosH5 from "../ad/cocos/AdCocosH5";
import AdDob5 from "../ad/dob5/AdDob5";
import AdTT from "../ad/TT/AdTT";
import AdXiaoXiong from "../ad/xiaoXiong/AdXiaoXiong";
import { E_AdType, E_PlatformType } from "../EnumBase";
import Ad4399 from "./Ad399/Ad4399";
import DataAnalyze, { E_DataAnalyzeType } from "./DataAnalyze";
import GameDistribution from "./gameDistribution/GameDistribution";
import GameMonetize from "./gameMonetize/GameMonetize";
import AdGoogleADM_Call from "./googleADM/AdGoogleADM";
var ccclass = _decorator.ccclass;
export var E_ADUrl;

(function (E_ADUrl) {
  E_ADUrl["Dob5_Sdk"] = "https://imasdk.googleapis.com/js/sdkloader/ima3.js";
  E_ADUrl["Dob5_Game"] = "https://www.dob5.com/skin/js/api-game-191223.js";
  E_ADUrl["Dob5_Statistics"] = "";
  E_ADUrl["Dob5_URL"] = "https://www.dob5.com/?from=Draw The Line 3D Online";
})(E_ADUrl || (E_ADUrl = {}));

var AdCtr = ccclass(_class = (_temp = _class2 = /*#__PURE__*/function () {
  function AdCtr() {
    _defineProperty(this, "_ad", null);

    _defineProperty(this, "type", E_AdType.None);

    _defineProperty(this, "platformType", E_PlatformType.GameMonetize);
  }

  var _proto = AdCtr.prototype;

  // public videoType: AdVideo_Type = AdVideo_Type.shopGain;
  _proto.init = function init() {
    switch (this.platformType) {
      case E_PlatformType.Cocos:
        this._ad = new AdCocos();
        break;

      case E_PlatformType.Dob5:
        this._ad = new AdDob5();
        break;

      case E_PlatformType.XiaoXiong:
        this._ad = new AdXiaoXiong();
        break;

      case E_PlatformType.ChuanYin:
        this._ad = new AdChuanYin();
        break;

      case E_PlatformType.Cocos_h5:
        this._ad = new AdCocosH5();
        break;

      case E_PlatformType.Aunit:
        // this._ad = AdSunit.I;
        break;

      case E_PlatformType.TT:
        this._ad = new AdTT();
        break;

      case E_PlatformType.Ad4399:
        this._ad = new Ad4399();
        break;

      case E_PlatformType.GoogleADM:
        this._ad = new AdGoogleADM_Call();
        break;

      case E_PlatformType.GameDistributions:
        this._ad = new GameDistribution();
        break;

      case E_PlatformType.GameMonetize:
        this._ad = new GameMonetize();
        break;

      case E_PlatformType.XiaoMi:
        this._ad = new AdDob5();
        this.init_patch();
        break;

      default:
        break;
    }

    if (this._ad) {
      this._ad.init();
    }
  }
  /**展示状态  - banner */
  ;

  _proto.isBanner = function isBanner() {
    return this._ad.isBannering;
  }
  /**创建 banner */
  ;

  _proto.createBannerAd = function createBannerAd() {
    if (!this.isEnable()) return;

    this._ad.createBannerAd();
  }
  /**展示 banner */
  ;

  _proto.showBannerAd = function showBannerAd() {
    if (!this.isEnable()) return;

    this._ad.showBannerAd();
  }
  /**隐藏 banner */
  ;

  _proto.hideBannerAd = function hideBannerAd() {
    this._ad.hideBannerAd();
  }
  /*** 创建 插屏*/
  ;

  _proto.createInterstitialAd = function createInterstitialAd() {
    if (!this.isEnable()) return;

    this._ad.createInterstitialAd();
  }
  /*** 展示插屏*/
  ;

  _proto.showInterstitialAd = function showInterstitialAd() {
    if (!this.isEnable()) return;

    if (sys.isNative) {
      DataAnalyze.I.ad(E_DataAnalyzeType.Interstitial_Begin);

      this._ad.showInterstitialAd();
    }
  } //激励视频

  /*** 创建 视频*/
  ;

  _proto.createRewardedVideoAd = function createRewardedVideoAd() {
    if (!this.isEnable()) return;

    this._ad.createRewardedVideoAd();
  }
  /*** 展示视频*/
  ;

  _proto.showRewardedVideoAd = function showRewardedVideoAd() {
    if (!this.isEnable()) return;
    DataAnalyze.I.ad(E_DataAnalyzeType.Ad_Begin);

    this._ad.showRewardedVideoAd();
  };

  _proto.isJSBAd = function isJSBAd() {
    return sys.isNative;
  }
  /**
   * @returns 是否可以播放广告
   */
  ;

  _proto.isEnable = function isEnable() {
    if (this.platformType == E_PlatformType.Normal) {
      return false;
    }

    if (this._ad && this._ad.isEnable) {
      return this._ad.isEnable();
    }

    return true;
  };

  _proto.init_patch = function init_patch() {
    var scriptL = document.createElement("script");
    scriptL.setAttribute("type", "text/javascript");
    scriptL.setAttribute("src", "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js");
    document.body.appendChild(scriptL);
  };

  _proto.closeAd = function closeAd() {
    var box = document.getElementById("googleAdBoxNew");

    if (box != null) {
      //@ts-ignore
      box.parentNode.removeChild(box);
    }
  };

  _proto.showAd = function showAd() {
    var googleAdBoxNew = document.getElementById("googleAdBoxNew");

    if (googleAdBoxNew == null) {
      googleAdBoxNew = document.createElement("div");
      googleAdBoxNew.id = 'googleAdBoxNew';
      var newadbox = document.createElement("div");
      newadbox.id = 'newadbox';
      googleAdBoxNew.appendChild(newadbox);
      newadbox.innerHTML = "<ins class='adsbygoogle' style='display:block' data-ad-client='ca-pub-6286294410238482' data-ad-slot='1925087502' data-ad-format='auto' data-full-width-responsive='true'></ins>";
      var nweadL = document.createElement("script");
      nweadL.innerHTML = "(adsbygoogle = window.adsbygoogle || []).push({});";
      newadbox.appendChild(nweadL);
      document.body.appendChild(googleAdBoxNew);
    }
  };

  _createClass(AdCtr, null, [{
    key: "I",
    get: function get() {
      if (!AdCtr._I) {
        AdCtr._I = new AdCtr();
      }

      return AdCtr._I;
    }
    /**广告实例 */

  }]);

  return AdCtr;
}(), _defineProperty(_class2, "_I", null), _temp)) || _class;

export { AdCtr as default };

_cclegacy._RF.pop();